@if (flightLevels()) {
  <jmkw-select
    [items]="flightLevels()"
    order="desc"
    [fontSizeRem]="0.8"
    [initialValue]="initialValue"
    (selectionChanged)="onSelectionChangeHandler($event)"
    >Flight Level</jmkw-select
    >
  }
